// eslint-disable-next-line max-classes-per-file
import React, { Component } from 'react';
import cl from 'classnames';
import PropTypes from 'prop-types';

import localitiesImgSq from '../../images/products/product-localities-sq.png';
import localitiesUkImgSq from '../../images/products/product-localities-uk-sq.png';
import geolocationImgSq from '../../images/products/product-geolocation-sq.png';
import storesImgSq from '../../images/products/product-stores-sq.png';
import distanceImgSq from '../../images/products/product-distance-sq.png';
import addressImgSq from '../../images/products/product-address-sq.png';
import mapImgSq from '../../images/products/product-map-sq.png';
import trafficImgSq from '../../images/products/product-traffic-sq.png';
import merchantImgSq from '../../images/products/product-merchant-sq.png';
import indoorImgSq from '../../images/products/product-indoor-sq.png';

const productImg = {
    LOCALITIES: localitiesImgSq,
    LOCALITIES_ADDRESS_UK: localitiesUkImgSq,
    GEOLOCATION: geolocationImgSq,
    STORES: storesImgSq,
    DISTANCE: distanceImgSq,
    ADDRESS: addressImgSq,
    MAP: mapImgSq,
    TRAFFIC: trafficImgSq,
    MERCHANTS: merchantImgSq,
    INDOOR: indoorImgSq,
};

class Footer extends Component {
    render() {
        const { products, ...rest } = this.props;
        return products.map((product) => (
            <div className="use-case__product-item" {...rest} key={product.id}>
                <img className="use-case__product-item__image" src={productImg[product.id]} alt={product.name} />
                <span className="use-case__product-item__name">{product.name}</span>
            </div>
        ));
    }
}

Footer.propTypes = {
    products: PropTypes.array.isRequired,
};

class UseCase extends Component {
    constructor(props) {
        super(props);
        this.state = { stateSelected: false };
    }

    onClick = () => {
        const { stateSelected } = this.state;
        const { isSelectable } = this.props;
        if (isSelectable) {
            this.setState({ stateSelected: !stateSelected });
        }
    };

    render() {
        const { className, children, isSelectable, testId, useCaseStory, productId, ...rest } = this.props;
        const { stateSelected } = this.state;
        const classes = cl(
            'use-case',
            { 'use-case--selectable': isSelectable },
            { 'use-case--selected': stateSelected },
            `use-case__story--${useCaseStory}`,
            className
        );
        return (
            <div
                className={classes}
                role="button"
                data-testid={testId}
                onClick={this.onClick}
                onKeyDown={() => {}}
                tabIndex="-1"
                id={productId}
                {...rest}
            >
                <div className="use-case__image" />
                <div className="use-case__content">{children}</div>
            </div>
        );
    }
}

UseCase.defaultProps = {
    testId: 'usecase',
    className: '',
    isSelectable: false,
    productId: '',
    useCaseStory: PropTypes.oneOf([
        'storeLocator',
        'productLocator',
        'addressAutocomplete',
        'ecommerceCheckout',
        'fleetTracking',
        'geocoding',
        'indoor',
        'products',
    ]),
};

UseCase.propTypes = {
    children: PropTypes.node.isRequired,
    testId: PropTypes.string,
    className: PropTypes.string,
    isSelectable: PropTypes.bool,
    useCaseStory: PropTypes.string,
    productId: PropTypes.string,
};

export default Object.assign(UseCase, {
    Footer,
});
